import { AgCharts } from "ag-charts-react";
import { useTranslation } from "react-i18next";

import { LoadingContainer } from "../../common/loaders/loadingcontainer";
import { localized } from "../../common/utils";
import { useGetPersonnelDimensions } from "../../api/endpoints";
import { oneDayMs } from "../../api";


export function PersonnelCount({ cardProps, changeProperty }) {
  const { t } = useTranslation();

  const { data: personnelDimensions } = useGetPersonnelDimensions({
    query: {
      staleTime: oneDayMs,
    },
  });

  /** @type {import("ag-grid-enterprise").AgChartOptions} */
  const pieChartOptions = {
    data: personnelDimensions && personnelDimensions[cardProps.dim ?? 0].items,
    series: [
      {
        type: "pie",
        angleKey: "count",
        calloutLabelKey: "label",
        sectorLabelKey: "count",
        sectorLabel: {
          color: "white",
          fontWeight: "bold",
        },
        tooltip: {
          renderer: ({ datum }) => ({
            heading: `${datum.share} %`,
            title: datum.label,
            data: [],
          }),
        },
        fills: ["#00B8E4", "#6F42C1", "#003A78", "#08384F", "#B7A0E0", "#80DBF1"],
      },
    ],
    legend: {
      enabled: false,
    },
    locale: localized.agChartsLocale,
  };


  return personnelDimensions ? (
    <>
      <h4 style={{ color: "var(--heeros-blue)" }}>{t("PersonnelCount", "Henkilöstömäärä")} %
        <select style={{ fontSize: "revert", marginLeft: ".5em", verticalAlign: "bottom" }} onChange={(e) => changeProperty("dim", e.target.value)} defaultValue={cardProps.dim}>
          {personnelDimensions.map((dim, idx) => (
            <option key={idx} value={idx}>
              {dim.name === "org" ? t("Company", "Yritys") : dim.name}
            </option>
          ))}
        </select>
      </h4>
      <div>
        <AgCharts options={pieChartOptions} />
      </div>
    </>
  ) : (
    <LoadingContainer />
  );
}
